import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(theme => ({
  modal: {
    height: '100%',
    width: '100%',
  },
}));
